<template>
  <div :class="['export_interest_image_wrapper', themeKey]">
    <div
      v-for="name in exportTnterestImageTypes"
      :key="name"
      :class="name"
      :style="name === 'export_interest_image_main' ? scaleStyle : {}"
    >
      <div class="export_interest_image" @click="$emit('previewAllImages')">
        <div class="eii_banner">
          <img v-if="bannerImageUrl" :src="bannerImageUrl">
        </div>
        <div
          class="eii_body"
          :style="{
            marginTop: name === 'export_interest_image_clone' ? 0 : -11 + '%'
          }"
        >
          <header
            class="eii_banner_title"
            :class="{
              with_insurance_name: currentTheme && currentTheme.bannerNameBg
            }"
            :style="{
              paddingTop: currentTheme && currentTheme.bannerNameBg ? '8%' : '11%'
            }"
          >
            <p>{{ productTitle }}</p>
          </header>
          <div class="eii_body_content">
            <div v-if="personData" class="eii_product_info">
              <dl>
                <dt>{{ title }}</dt>
                <template v-if="productInterestInfoList && productInterestInfoList.length">
                  <dd v-for="item in productInterestInfoList" :key="item.label + item.name">
                    <label v-html="item.label" />
                    <span>{{ item.name }}</span>
                  </dd>
                </template>
              </dl>
            </div>
            <InterestTableWithRemark
              v-if="tableData && interestData"
              scene="export"
              :person-data="personData"
              :product-form-data="interestData.curProductFormData"
              :product-interest-data="interestData.curProductInterestData"
              :product-result-data="interestData.curProductResultData"
              :interest-detail-data="interestData.interestDetailWithRemark"
              class="interest_table2024__export"
            />
            <div v-if="isShowBusinessCard && cardInfo" class="eii_card_info">
              <div v-if="!['H5_BXZ'].includes(APP_CHANNEL)" class="left">
                <img v-if="cardInfo.photo" :src="cardInfo.photo" alt="photo">
                <div class="desc">
                  <p>{{ cardInfo.name }}</p>
                  <p>{{ cardInfo.telephone }}</p>
                </div>
              </div>
              <div class="right">
                <img v-if="resultUrlQRCodeImage" :src="resultUrlQRCodeImage" alt="">
                <div class="desc">
                  <p>请扫码查看详细内容</p>
                </div>
              </div>
            </div>
            <div
              v-if="riskPromptLines && riskPromptLines.length"
              class="eii_risk_prompt"
            >
              <dl>
                <dd v-for="(line, idx) in riskPromptLines" :key="idx">
                  <p>{{ line }}</p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span
      v-if="isIos"
      class="export_interest_rerender"
      data-stat-id="JHS_JGY_LYBGDC_CXXL"
      @click.stop="onClickReRenderImage"
    >
      <i class="iconfont icon-refresh" />
      重新生成图片
    </span>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import QS from 'qs'
import axios from 'axios'
import { get as _get, cloneDeep } from 'lodash'
import QRCode from 'qrcode'
import { Picker } from 'bxs-ui-vue'

import { IS_LOCALHOST_ENV, isAndroid, URL_PARAM, domToImageToPng, htmlToImageToPng, modernScreenshotToPng, imageUrlToBase64 } from 'common/utils'
import { formatCalculateData } from 'common/js/format'
import { normalizeKeys } from 'base/config'
import InterestTableWithRemark from '@/pages/planbkTemplatev2/components/interest-table/index.vue'
import { getRiskPromptLines } from '@/pages/planbkTemplatev2/components/risk/content'

// const ROOT_FONT_SIZE = 39
Vue.use(Picker)
export default {
  components: {
    InterestTableWithRemark
  },
  props: {
    scene: Number,
    resultData: {
      type: Object,
      default: () => ({})
    },
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    isShowBusinessCard: {
      type: Boolean,
      default: true
    },
    cardImageData: String,
    riskHasInterestDemo: {
      type: Boolean,
      default: true
    },
    riskHasBonus: {
      default: undefined,
      validator: v => v === undefined || typeof v === 'boolean'
    }
  },
  data () {
    return {
      isIos: appBridge.isIos(),
      exportTnterestImageTypes: ['export_interest_image_main', 'export_interest_image_clone'],
      resultUrlQRCodeImage: null,
      cardInfo: null,
      scaleStyle: null,
      cacheImageDataUrl: {}
    }
  },
  computed: {
    ...mapState(['interestData', 'themeList']),
    themeKey () {
      return _get(this, 'themeSettings.previewTheme') || ''
    },
    currentTheme () {
      const themeList = _get(this, 'themeList') || []
      const option = themeList.find(o => o.key === this.themeKey)
      return option || themeList[0]
    },
    dataURLName () {
      return `${this.themeKey}_${this.isShowBusinessCard ? 'card' : 'nocard'}`
    },
    productTitle () {
      return _get(this, 'interestData.curProductInterestData.productName') || ''
    },
    title () {
      const _remarkTitle = _get(this, 'interestData.interestDetailWithRemark.remarkTitle') || ''

      const age = _get(this, 'personData.insuredInfo.age')
      const sex = _get(this, 'personData.insuredInfo.sex')
      const baofDesc = _get(this, 'personData.main.baofDesc')
      const pPeriodDesc = _get(this, 'personData.main.pPeriodDesc')
      const _title = `${age}岁${sex === 1 ? '男' : '女'}性 年交${baofDesc} ${pPeriodDesc === '趸交' ? pPeriodDesc : '交' + pPeriodDesc}`
      return _remarkTitle || _title
    },
    themeStyle () {
      const themeList = _get(this, 'themeList') || []
      const option = themeList.find(o => o.key === this.themeKey)
      return option || themeList[0]
    },
    // 若为 img.winbaoxian.com 域名则替换为 media.winbaoxian.com
    bannerImageUrl () {
      const url = _get(this.themeStyle, 'bannerImage') || ''
      if (!url) return ''
      return url.replace(/img\.winbaoxian\.com/g, 'media.winbaoxian.com')
      // return url
    },
    personData () {
      const { personData } = formatCalculateData(this.resultData.resultData, normalizeKeys)
      return personData
    },
    curProductPeriod () {
      const { curProductResultData } = this.interestData
      if (!curProductResultData) {
        return 0
      }
      const firstInsurance = curProductResultData.mulInsOrderList.find(ins => ins.key !== 'common')
      if (firstInsurance) {
        return firstInsurance.period
      }
      return 0
    },
    productInterestInfoList () {
      const { curProductFormData, interestFieldOptions } = this.interestData
      const formValues = _get(curProductFormData, 'formValues')
      if (!interestFieldOptions || !formValues) {
        return
      }
      const objs = {
        bonus: '分&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp红',
        rate: '账户利率',
        drawData: '减保领取',
        addAndTakeData: '追加领取',
      }
      const keys = ['bonus', 'rate', 'drawData', 'addAndTakeData']
      return keys.map(k => {
        const item = interestFieldOptions.find(e => e.key === k)
        const options = item && item.options
        const option = options && options.find(o => k === 'rate' ? o.index === formValues.rateIndex : o.value === formValues[k])

        let name = ''
        if (k === 'bonus' && option) {
          name = option.description
        }
        if (k === 'rate' && option) {
          name = formValues.rateIndex === -1 ? '自定义利率' + `(${(curProductFormData.customRate * 100).toFixed(2)}%)` : option.description
        }
        if (k === 'drawData' && options && options.length) {
          name = `${objs[k]}${!formValues.drawFlag ? '前' : '后'}`
        }
        if (k === 'addAndTakeData' && options && options.length) {
          name = `${objs[k]}${!formValues.addAndTakeFlag ? '前' : '后'}`
        }
        return {
          label: objs[k],
          name
        }
      }).filter(e => e.name)
    },
    tableData () {
      const tableData = cloneDeep(_get(this.interestData, 'interestTableData'))
      return tableData || []
    },
    riskPromptLines () {
      return getRiskPromptLines({
        plainResultData: this.resultData,
        interestData: this.interestData,
        riskHasInterestDemo: this.riskHasInterestDemo,
        riskHasBonus: this.riskHasBonus
      })
    }
  },
  watch: {
    isShowBusinessCard () {
      this.scaleInterestTable()
    },
    themeKey () {
      this.getUrlQRCode()
      this.scaleInterestTable()
    },
    productInterestInfoList () {
      this.cacheImageDataUrl = {}
    },
    tableData () {
      this.cacheImageDataUrl = {}
      this.scaleInterestTable()
    },
  },
  async created () {
    this.getUrlQRCode()
    const card = cloneDeep(_get(this.resultData, 'card'))
    if (card && card.photo && !card.photo.includes('?x-oss-process=')) {
      card.photo = card.photo + '?x-oss-process=image/resize,m_mfit,h_180,w_180'
      card.photo = (await imageUrlToBase64(card.photo).catch(() => '')) || card.photo
    }
    this.cardInfo = card
  },
  mounted () {
    const self = this
    self.scaleInterestTable()
    setTimeout(() => {
      self.scaleInterestTable()
    }, 1000)
  },
  methods: {
    async getUrlQRCode () {
      const { resultData, themeKey : theme } = this
      const { uuid, cardUuid } = URL_PARAM
      const resultParams = {
        uuid,
        theme,
        cardUuid: cardUuid || _get(resultData, 'card.uuid')
      }
      const resultUrl = `${location.origin}${location.pathname}?${QS.stringify(resultParams)}`
      this.resultUrlQRCodeImage = await QRCode.toDataURL(resultUrl, {
        width: 120,
        margin: 0
      })
    },
    scaleInterestTable () {
      const self = this
      const { scene } = self
      self.$nextTick(() => {
        const wrapperDom = document.querySelector('.export_interest_image_wrapper')
        if (!wrapperDom) {
          return
        }
        const parentDom = wrapperDom.parentElement
        const interestDom = wrapperDom.querySelector('.export_interest_image_main .export_interest_image')
        if (!parentDom || !interestDom) {
          return
        }
        const scaleWidth = (parentDom.offsetWidth - 24 * 2) / interestDom.offsetWidth
        self.scaleStyle = {
          transform: `scale(${scaleWidth}) translate(${24 / scaleWidth}px, ${24 / scaleWidth}px)`,
          transformOrigin: `left top`,
        }
        if ([1, 3].includes(scene)) {
          parentDom.style.alignItems = 'start'
          wrapperDom.style.height = (interestDom.offsetHeight * scaleWidth + 24 * 2) + 'px'
        } else {
          parentDom.style.height = (interestDom.offsetHeight * scaleWidth + 24 * 2) + 'px'
        }
      })
    },
    async optimizeBannerImageUrl (imageUrl) {
      if (!imageUrl) return ''
      try {
        const MAX_WIDTH = 1206 // iPhone 17 屏幕宽度
        const response = await axios.get(imageUrl,{params:{'x-oss-process':'image/info'}, withCredentials: false, responseType: 'json'})
        const imageInfo = response.data

        const imageHeight = parseInt(imageInfo.ImageHeight?.value || 0)
        const imageWidth = parseInt(imageInfo.ImageWidth?.value || 0)

        if (imageWidth > MAX_WIDTH) {
          console.warn('图片宽度过大，缩放图片:', imageUrl, `${imageWidth}x${imageHeight} → ${MAX_WIDTH}px宽`)
          const separator = imageUrl.includes('?') ? '&' : '?'
          return `${imageUrl}${separator}x-oss-process=image/resize,w_${MAX_WIDTH}`
        }

        return imageUrl
      } catch (error) {
        console.warn('获取图片尺寸信息失败，使用原始 URL:', error, imageUrl)
        return imageUrl
      }
    },
    async generateImage (isShowLoading = true) {
      const self = this
      const { cacheImageDataUrl, dataURLName } = self
      if (cacheImageDataUrl[dataURLName]) {
        return cacheImageDataUrl[dataURLName]
      }
      const _wrapperDom = document.querySelector('.export_interest_image_clone .export_interest_image')
      const _bodyDom = document.querySelector('.export_interest_image_clone .export_interest_image .eii_body')
      if (_bodyDom) {
        if (isShowLoading) {
          appBridge.showLoading()
        }
        // fix 兼容问题：部分安卓机（如：Redmi Note 12 Turbo），导出图片最后一行不全。
        if (isAndroid) {
          const tableDom = _bodyDom.querySelector('.interest_table_main .table_wrapper.normal table')
          const cells = tableDom ? tableDom.querySelectorAll('tr, th') || [] : []
          cells.forEach(c => {
            c.style.height = `${Math.round(c.offsetHeight)}px`
          })
        }
        return new Promise((resolve) => {
          setTimeout(async () => {
            const _bannerImage = await self.optimizeBannerImageUrl(self.bannerImageUrl)
            // const _dataUrl = await domToImageToPng(_bodyDom) || ''
            // const _dataUrl = await htmlToImageToPng(_bodyDom) || ''
            // 使用 _wrapperDom 作为 scale 计算基准，因为最终合并后的画布尺寸是基于 _wrapperDom 的
            const _dataUrl = await modernScreenshotToPng(_bodyDom, _wrapperDom) || ''
            const _backgroundColor = getComputedStyle(_wrapperDom).backgroundColor
            cacheImageDataUrl[dataURLName] = await self.mergeBase64ByCanvas([_bannerImage, _dataUrl].filter(e => !!e), {
              backgroundColor: _backgroundColor
            })
            if (IS_LOCALHOST_ENV) {
              if (cacheImageDataUrl[dataURLName]) {
                // console.log(cacheImageDataUrl[dataURLName])
                console.log(cacheImageDataUrl[dataURLName].substring(0, 100))
                console.log(cacheImageDataUrl[dataURLName].length)

                // const bannerDom = document.querySelector('.theme-banner img')
                // if (bannerDom) {
                //   bannerDom.src = cacheImageDataUrl[dataURLName]
                // }
              }
            }
            resolve(cacheImageDataUrl[dataURLName])
          }, 300)
        }).finally(() => {
          window.appBridge && appBridge.hideLoading()
        })
      }
      return Promise.resolve('')
    },
    async mergeBase64ByCanvas(images, options = {}) {
      let _dataURL = ''
      if (Array.isArray(images) && images.length) {
        if (images.length === 1) {
          _dataURL = images[0]
        } else {
          const { backgroundColor = '#f2f2f2' } = options
          const promises = images.map(url => {
            return new Promise((resolve, reject) => {
              const image = new Image()
              image.src = url
              image.crossOrigin = 'anonymous'
              image.onload = (img) => {
                resolve({
                  image,
                  width: img.target.width,
                  height: img.target.height
                })
              }
              image.onerror = (e) => {
                reject(e)
              }
            })
          })
          _dataURL = await Promise.all(promises).then(results => {
            const canvas = document.createElement('canvas')
            canvas.width = Math.max.apply(Math, results.map(img => img.width))
            canvas.height = results.reduce((accumulate, img) => {
              const _height = img.height * (canvas.width / img.width )
              return accumulate + _height
            }, 0)
            const marginTop = canvas.width * 0.11
            const ctx = canvas.getContext('2d')
            ctx.fillStyle = backgroundColor
            ctx.fillRect(0, 0, canvas.width, canvas.height - marginTop)

            let y = 0
            results.forEach((img, i) => {
              const _height = img.height * (canvas.width / img.width )
              ctx.drawImage(img.image, 0, y, canvas.width, _height)
              y += (i === 0 ? _height - marginTop : _height)
            })
            return canvas.toDataURL()
          })
        }
      }
      return _dataURL
    },
    onClickReRenderImage () {
      this.cacheImageDataUrl[this.dataURLName] = null
      this.$emit('previewAllImages')
    }
  }
}
</script>
<style>
@import './index.css';
</style>
